import React, { useState } from "react";
import { useCartProducts } from "src/business-types/laundry/modules/home/Bom/hooks/useCartProducts";
import CustomerInfo from "src/business-types/laundry/modules/home/Bom/parts/CustomerInfo";
import ProductTable from "src/business-types/laundry/modules/home/Bom/parts/ProductTable";
import { Props } from "src/business-types/laundry/modules/home/Bom/types/bomTypes";
import CommonButtons from "../../../../../shared/components/CommonButtons";
import Payment from "src/business-types/laundry/modules/home/Payment/Payment";
import { roundToTwoDecimalPlaces } from "../../../../grocery/hooks/useRound";
import { ModalWrapper } from "../../../../../shared/components/ModalWrapper";
import { putShoppingCart } from "src/shared/services/servicesv2";

const Bom: React.FC<Props> = ({ cartId, customerData, customerid, backHomebom, backHome, onDone, editedAmounts }) => {
  const [payment, setPayment] = useState(false);
  const [backpage, setBackpage] = useState(false);
  const { products } = useCartProducts(cartId, customerid);

  const allProducts = products.flatMap((item) => item.products);
  const totalAmount = roundToTwoDecimalPlaces(products.reduce((sum, item) => sum + parseFloat(item.orderAmount || "0"), 0));

  const updateData = () => {
    putShoppingCart(cartId || "", { customerId: customerid })
      .then(() => setPayment(true))
      .catch(console.error);
  };

  // ✅ Reset everything in Bom
  const resetAll = () => {
    setPayment(false);
    setBackpage(false);
    backHome("false"); // fully close BOM
    backHomebom(); // reset PopupScreen view
    onDone();
  };

  const backHomepay = (data: string) => {
    if (data === "false" || data === "onlyfalse") {
      setPayment(false); // just close payment, go back to Bom
    }

    if (data === "done") {
      resetAll();
    }
  };
  if (backpage) return null;
  if (payment) return <Payment cartId={cartId} backHomepay={backHomepay} backHome={backHome} editedAmounts={editedAmounts}/>;

  return (
    <ModalWrapper
      title="Product details"
      onClose={() => backHome("false")}
      showBackButton
      onBack={() => backHomebom()}
      className="min-w-[580px]"
      width="max-w-2xl"
      positionClass="top-0 left-0 right-0 mt-16 h-full"
    >
      <div className="space-y-4">
        <CustomerInfo customer={customerData} onAddProduct={() => backHome("false")} />
        <div className="thin-scrollbar w-full min-w-[530px] h-[350px] overflow-y-auto">
          <ProductTable items={allProducts} editedAmounts={editedAmounts} />
        </div>
      </div>
      <div className="flex justify-between items-center w-full px-0.5 mt-6">
        <h3 className="px-0.5">Total Amount : {totalAmount.toFixed(2)} QAR</h3>
        <CommonButtons label="Order Confirm" className="w-36" onClick={updateData} />
      </div>
    </ModalWrapper>
  );
};

export default Bom;
